export default "__VITE_ASSET__7Nm8EZyG__"